import ChallengeInfoForm from "./ChallengeInfoForm";

export default function ChallengeForm({ row: challengeRow, onEdit, onCreate }) {
  return <ChallengeInfoForm challenge={challengeRow} onEdit={onEdit} onCreate={onCreate} />;
}
